import { render, staticRenderFns } from "./quesInstru6.vue?vue&type=template&id=a640471c"
import script from "./quesInstru6.vue?vue&type=script&lang=js"
export * from "./quesInstru6.vue?vue&type=script&lang=js"
import style0 from "./quesInstru6.vue?vue&type=style&index=0&id=a640471c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports